import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const PendingSetupPage = () => {
  const { logout } = useAuth();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="background.default"
      p={2}
    >
      <Paper elevation={3} sx={{ p: 4, maxWidth: 480, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          Account Pending Setup
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Your account has been created but hasn't been assigned to a business yet.
          Please contact your administrator to complete the setup.
        </Typography>
        <Button variant="outlined" onClick={logout}>
          Sign Out
        </Button>
      </Paper>
    </Box>
  );
};

export default PendingSetupPage;
